<!-- Main container following application layout patterns -->
<div class="main-content">
    <!-- Header section consistent with other pages -->
    <div *ngIf="canRead()">
        <div class="header-section">
            <div class="d-flex justify-content-between align-items-center">
                <div class="wm-heading">
                    <div class="wm-heading-icon"><i class="fas fa-clipboard-list"></i></div>
                    <div>
                        <h1 class="main-title">{{ 'SHIPMENT_MANAGEMENT.TITLE' | translate }}</h1>
                        <p class="main-subtitle">{{ 'SHIPMENT_MANAGEMENT.SUBTITLE' | translate }}</p>
                    </div>
                </div>

                <!-- Strumentario -->
                <div class="toolbox-container">
                    <div class="toolbox-heading">
                        <div class="toolbox-heading-icon">
                            <i class="fas fa-tools"></i>
                        </div>
                        <div class="toolbox-heading-text">
                            <span class="toolbox-title">Strumentario</span>
                            <small class="toolbox-subtitle">Strumenti rapidi</small>
                        </div>
                    </div>
                    <div class="toolbox-divider"></div>
                    <div class="toolbox-buttons">

                        <!-- Tour guidato -->
                        <button type="button" class="toolbox-btn toolbox-btn--blue" (click)="startTour()"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                [title]="'TOUR.START_TOUR' | translate">
                            <i class="fas fa-route"></i>
                        </button>

                        <!-- Aggiorna dati -->
                        <button type="button" class="toolbox-btn toolbox-btn--green" (click)="refreshData()"
                                [disabled]="isSearchLoading || isAdvancedSearchLoading"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Aggiorna i dati (ri-esegue la ricerca con i filtri correnti)">
                            <i class="fas fa-sync-alt" [class.fa-spin]="isSearchLoading || isAdvancedSearchLoading"></i>
                        </button>

                        <!-- Comprimi/Espandi sezioni -->
                        <button type="button" class="toolbox-btn toolbox-btn--purple" (click)="toggleAllSections()"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Comprimi/Espandi filtri e resoconto">
                            <i class="fas" [ngClass]="areAllSectionsCollapsed ? 'fa-expand-alt' : 'fa-compress-alt'"></i>
                        </button>

                        <!-- Densità tabella -->
                        <button type="button" class="toolbox-btn toolbox-btn--orange" [class.active]="isCompactTable"
                                (click)="toggleCompactTable()"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Attiva/Disattiva la vista compatta della tabella">
                            <i class="fas fa-grip-lines"></i>
                        </button>

                        <!-- Gestione colonne (apre il pannello nell'header della sezione risultati) -->
                        <button type="button" class="toolbox-btn toolbox-btn--red"
                                [class.active]="isColumnsPanelOpen || isColumnLayoutCustomized"
                                (click)="openColumnsPanelFromToolbox()"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Gestisci visibilità e posizione delle colonne della tabella">
                            <i class="fas fa-columns"></i>
                        </button>
                    </div>
                </div>
            </div>

        </div>

        <!-- Sezione Filtri e Azioni -->
        <div id="filters-section" class="card mb-4">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="header-title">
                        <i class="fas fa-filter header-icon"></i>
                        <h3>{{ 'SHIPMENT_MANAGEMENT.FILTERS_AND_ACTIONS' | translate }}</h3>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="toggleFiltersCollapsed()"
                            [title]="isFiltersCollapsed ? ('COMMON.EXPAND' | translate) : ('COMMON.COLLAPSE' | translate)">
                        <i class="fas" [ngClass]="isFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                    </button>
                </div>
            </div>

            <div class="card-body" *ngIf="!isFiltersCollapsed">
                <!-- Filtri Principali (sempre visibili) -->
                <div id="basic-filters" class="row g-3">
                    <div class="col-md-3">
                        <label class="form-label">
                            {{ 'SHIPMENT_MANAGEMENT.FILTER_PARCEL_CODE' | translate }}
                        </label>
                        <div class="filter-input-wrapper">
                            <i class="fas fa-box filter-icon"></i>
                            <input type="text" class="filter-input" [(ngModel)]="filterParcelCode"
                                   (input)="onRequiredFilterChange()"
                                   [placeholder]="'SHIPMENT_MANAGEMENT.FILTER_PARCEL_CODE_PLACEHOLDER' | translate">
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">
                            {{ 'SHIPMENT_MANAGEMENT.FILTER_WAYBILL_CODE' | translate }}
                        </label>
                        <div class="filter-input-wrapper">
                            <i class="fas fa-barcode filter-icon"></i>
                            <input type="text" class="filter-input" [(ngModel)]="filterWaybillCode"
                                   (input)="onRequiredFilterChange()"
                                   [placeholder]="'SHIPMENT_MANAGEMENT.FILTER_WAYBILL_CODE_PLACEHOLDER' | translate">
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">
                            {{ 'SHIPMENT_MANAGEMENT.FILTER_DEALER_CODE' | translate }}
                        </label>
                        <div class="filter-input-wrapper">
                            <i class="fas fa-store filter-icon"></i>
                            <input type="text" class="filter-input" [(ngModel)]="filterDealerCode"
                                   (input)="onRequiredFilterChange()"
                                   [placeholder]="'SHIPMENT_MANAGEMENT.FILTER_DEALER_CODE_PLACEHOLDER' | translate">
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">
                            {{ 'SHIPMENT_MANAGEMENT.STATUS' | translate }}
                        </label>
                        <app-searchable-select
                                [(ngModel)]="filterStatus"
                                [options]="statusOptions"
                                allOptionLabel="Tutti gli stati"
                                icon="fas fa-flag"
                                searchPlaceholder="Cerca stato..."
                                (valueChange)="onRequiredFilterChange()">
                        </app-searchable-select>
                    </div>
                </div>

                <!-- Pulsante Filtri Avanzati (sotto i filtri principali) -->
                <div class="row g-3 mt-2">
                    <div class="col-12">
                        <button type="button" class="btn btn-outline-secondary d-flex align-items-center justify-content-center w-100 advanced-filters-toggle"
                                (click)="toggleAdvancedFilters()"
                                [title]="isAdvancedFiltersCollapsed ? ('SHIPMENT_MANAGEMENT.SHOW_ADVANCED_FILTERS' | translate) : ('SHIPMENT_MANAGEMENT.HIDE_ADVANCED_FILTERS' | translate)">
                            <i class="fas fa-sliders-h me-2"></i>
                            {{ 'SHIPMENT_MANAGEMENT.ADVANCED_FILTERS' | translate }}
                            <i class="fas ms-2" [ngClass]="isAdvancedFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                        </button>
                    </div>
                </div>

                <!-- Filtri Avanzati (collassabili) -->
                <div class="mt-3">
                    <div id="advanced-filters" class="collapse" [ngClass]="{'show': !isAdvancedFiltersCollapsed}" style="transition: all 0.3s ease;">
                        <div class="border-top pt-3 mt-3">
                            <div class="row g-3">
                                <div class="col-md-3">
                                    <label class="form-label">
                                        {{ 'SHIPMENT_MANAGEMENT.FILTER_DATE_FROM' | translate }}
                                    </label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-calendar-plus filter-icon"></i>
                                        <input #filterDateFromInput
                                               type="text"
                                               class="filter-input"
                                               [value]="getFormattedFilterDateFrom()"
                                               (click)="openFilterDateFromPicker()"
                                               (focus)="openFilterDateFromPicker()"
                                               readonly
                                               [placeholder]="'SHIPMENT_MANAGEMENT.FILTER_DATE_FROM_PLACEHOLDER' | translate">
                                        <div class="date-navigation-controls">
                                            <div class="date-nav-separator"></div>
                                            <button type="button" class="date-nav-btn" (click)="decrementFilterDateFrom()" title="Giorno precedente">
                                                <i class="fas fa-chevron-left"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="setFilterDateFromToday()" title="Oggi">
                                                <i class="fas fa-calendar-day"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="incrementFilterDateFrom()" title="Giorno successivo">
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="clearFilterDateFrom()" title="Cancella data">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">
                                        {{ 'SHIPMENT_MANAGEMENT.FILTER_DATE_TO' | translate }}
                                    </label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-calendar-minus filter-icon"></i>
                                        <input #filterDateToInput
                                               type="text"
                                               class="filter-input"
                                               [value]="getFormattedFilterDateTo()"
                                               (click)="openFilterDateToPicker()"
                                               (focus)="openFilterDateToPicker()"
                                               readonly
                                               [placeholder]="'SHIPMENT_MANAGEMENT.FILTER_DATE_TO_PLACEHOLDER' | translate">
                                        <div class="date-navigation-controls">
                                            <div class="date-nav-separator"></div>
                                            <button type="button" class="date-nav-btn" (click)="decrementFilterDateTo()" title="Giorno precedente">
                                                <i class="fas fa-chevron-left"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="setFilterDateToToday()" title="Oggi">
                                                <i class="fas fa-calendar-day"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="incrementFilterDateTo()" title="Giorno successivo">
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="clearFilterDateTo()" title="Cancella data">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Data Consegna stimata</label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-calendar-check filter-icon"></i>
                                        <input #filterEstimatedDeliveryInput
                                               type="text"
                                               class="filter-input"
                                               [value]="getFormattedFilterEstimatedDelivery()"
                                               (click)="openFilterEstimatedDeliveryPicker()"
                                               (focus)="openFilterEstimatedDeliveryPicker()"
                                               readonly
                                               placeholder="Data consegna stimata">
                                        <div class="date-navigation-controls">
                                            <div class="date-nav-separator"></div>
                                            <button type="button" class="date-nav-btn" (click)="decrementFilterEstimatedDelivery()" title="Giorno precedente">
                                                <i class="fas fa-chevron-left"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="setFilterEstimatedDeliveryToday()" title="Oggi">
                                                <i class="fas fa-calendar-day"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="incrementFilterEstimatedDelivery()" title="Giorno successivo">
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="clearFilterEstimatedDelivery()" title="Cancella data">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Data Consegna effettiva</label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-calendar-day filter-icon"></i>
                                        <input #filterActualDeliveryInput
                                               type="text"
                                               class="filter-input"
                                               [value]="getFormattedFilterActualDelivery()"
                                               (click)="openFilterActualDeliveryPicker()"
                                               (focus)="openFilterActualDeliveryPicker()"
                                               readonly
                                               placeholder="Data consegna effettiva">
                                        <div class="date-navigation-controls">
                                            <div class="date-nav-separator"></div>
                                            <button type="button" class="date-nav-btn" (click)="decrementFilterActualDelivery()" title="Giorno precedente">
                                                <i class="fas fa-chevron-left"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="setFilterActualDeliveryToday()" title="Oggi">
                                                <i class="fas fa-calendar-day"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="incrementFilterActualDelivery()" title="Giorno successivo">
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                            <button type="button" class="date-nav-btn" (click)="clearFilterActualDelivery()" title="Cancella data">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Magazzino</label>
                                    <app-searchable-select
                                            [(ngModel)]="filterWarehouse"
                                            savedSelectionsKey="shipment-management.warehouse"
                                            [options]="warehouseSelectOptions"
                                            [multiple]="true"
                                            allOptionLabel="Tutti i magazzini"
                                            icon="fas fa-warehouse"
                                            searchPlaceholder="Cerca magazzino..."
                                            (valueChange)="onUnifiedFilterChange()">
                                    </app-searchable-select>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">
                                        {{ 'SHIPMENT_MANAGEMENT.FILTER_CARRIER' | translate }}
                                    </label>
                                    <app-searchable-select
                                            [(ngModel)]="filterCarrier"
                                            savedSelectionsKey="shipment-management.carrier"
                                            [options]="carrierSelectOptions"
                                            [multiple]="true"
                                            [allOptionLabel]="'SHIPMENT_MANAGEMENT.ALL_CARRIERS' | translate"
                                            icon="fas fa-shipping-fast"
                                            searchPlaceholder="Cerca corriere..."
                                            (valueChange)="onUnifiedFilterChange()">
                                    </app-searchable-select>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">
                                        {{ 'SHIPMENT_MANAGEMENT.FILTER_CUSTOMER' | translate }}
                                    </label>
                                    <app-searchable-select
                                            [(ngModel)]="filterCustomer"
                                            savedSelectionsKey="shipment-management.customer"
                                            [options]="clientSelectOptions"
                                            [multiple]="true"
                                            [allOptionLabel]="'SHIPMENT_MANAGEMENT.ALL_CUSTOMERS' | translate"
                                            icon="fas fa-users"
                                            searchPlaceholder="Cerca cliente..."
                                            (valueChange)="onUnifiedFilterChange()">
                                    </app-searchable-select>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">
                                        {{ 'SHIPMENT_MANAGEMENT.FILTER_BRAND' | translate }}
                                    </label>
                                    <app-searchable-select
                                            [(ngModel)]="filterBrand"
                                            savedSelectionsKey="shipment-management.brand"
                                            [options]="brandSelectOptions"
                                            [multiple]="true"
                                            [allOptionLabel]="'SHIPMENT_MANAGEMENT.ALL_BRANDS' | translate"
                                            icon="fas fa-tag"
                                            searchPlaceholder="Cerca brand..."
                                            (valueChange)="onUnifiedFilterChange()">
                                    </app-searchable-select>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">
                                        {{ 'SHIPMENT_MANAGEMENT.FILTER_ROUTING' | translate }}
                                    </label>
                                    <app-searchable-select
                                            [(ngModel)]="filterRouting"
                                            savedSelectionsKey="shipment-management.routing"
                                            [options]="zoneSelectOptions"
                                            [multiple]="true"
                                            [allOptionLabel]="'SHIPMENT_MANAGEMENT.ALL_ROUTINGS' | translate"
                                            icon="fas fa-route"
                                            searchPlaceholder="Cerca instradamento..."
                                            (valueChange)="onUnifiedFilterChange()">
                                    </app-searchable-select>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Ragione Sociale</label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-building filter-icon"></i>
                                        <input type="text" class="filter-input" [(ngModel)]="filterCompanyName"
                                               (input)="onRequiredFilterChange()"
                                               placeholder="Filtra per ragione sociale...">
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Indirizzo</label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-map-marker-alt filter-icon"></i>
                                        <input type="text" class="filter-input" [(ngModel)]="filterAddress"
                                               (input)="onRequiredFilterChange()"
                                               placeholder="Filtra per indirizzo...">
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Città</label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-city filter-icon"></i>
                                        <input type="text" class="filter-input" [(ngModel)]="filterCity"
                                               (input)="onRequiredFilterChange()"
                                               placeholder="Filtra per città...">
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Provincia</label>
                                    <div class="filter-input-wrapper">
                                        <i class="fas fa-map filter-icon"></i>
                                        <input type="text" class="filter-input" [(ngModel)]="filterProvince"
                                               (input)="onRequiredFilterChange()"
                                               placeholder="Filtra per provincia...">
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Tipologia Collo</label>
                                    <app-searchable-select
                                            [(ngModel)]="filterParcelType"
                                            [options]="parcelTypeOptions"
                                            allOptionLabel="Tutte le tipologie"
                                            icon="fas fa-box"
                                            searchPlaceholder="Cerca tipologia..."
                                            (valueChange)="onRequiredFilterChange()">
                                    </app-searchable-select>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Peso (kg)</label>
                                    <div class="filter-input-wrapper position-relative">
                                        <i class="fas fa-weight filter-icon"></i>
                                        <select class="filter-operator-select" [(ngModel)]="filterWeightOperator">
                                            <option *ngFor="let op of comparisonOperators" [value]="op.value">{{ op.label }}</option>
                                        </select>
                                        <input type="text" inputmode="decimal" step="0.01" min="0"
                                               class="filter-input with-operator" [(ngModel)]="filterWeight"
                                               (input)="onRequiredFilterChange()"
                                               placeholder="Filtra per peso...">
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Volume (m³)</label>
                                    <div class="filter-input-wrapper position-relative">
                                        <i class="fas fa-cube filter-icon"></i>
                                        <select class="filter-operator-select" [(ngModel)]="filterVolumeOperator">
                                            <option *ngFor="let op of comparisonOperators" [value]="op.value">{{ op.label }}</option>
                                        </select>
                                        <input type="text" inputmode="decimal" step="0.01" min="0"
                                               class="filter-input with-operator" [(ngModel)]="filterVolume"
                                               (input)="onRequiredFilterChange()"
                                               placeholder="Filtra per volume...">
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Colli Danneggiati</label>
                                    <div class="filter-input-wrapper damaged-filter-wrapper">
                                        <i class="fas fa-box-open filter-icon"></i>
                                        <span class="damaged-filter-text" [class.active]="filterDamagedParcels">
                                            {{ filterDamagedParcels ? 'Solo colli danneggiati' : 'Tutti i colli' }}
                                        </span>
                                        <button type="button" class="damaged-filter-switch"
                                                role="switch" [attr.aria-checked]="filterDamagedParcels"
                                                [class.active]="filterDamagedParcels"
                                                (click)="setFilterDamagedParcels(!filterDamagedParcels)"
                                                [title]="filterDamagedParcels ? 'Solo colli danneggiati' : 'Tutti i colli'">
                                            <span class="damaged-filter-switch-knob">
                                                <i class="fas" [ngClass]="filterDamagedParcels ? 'fa-box-open' : 'fa-box'"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Immagini Colli</label>
                                    <div class="filter-input-wrapper damaged-filter-wrapper">
                                        <i class="fas fa-image filter-icon"></i>
                                        <span class="damaged-filter-text" [class.active]="filterParcelImages !== 'ALL'">
                                            {{ parcelImagesFilterLabel }}
                                        </span>
                                        <!-- Toggle a 3 posizioni: tutti / con immagine / senza immagine -->
                                        <button type="button" class="tri-switch"
                                                aria-label="Filtro immagini colli"
                                                [attr.data-pos]="filterParcelImages"
                                                (click)="cycleFilterParcelImages()"
                                                [title]="parcelImagesFilterLabel + ' (clicca per cambiare)'">
                                            <span class="tri-switch-knob">
                                                <i class="fas"
                                                   [ngClass]="filterParcelImages === 'WITH' ? 'fa-image' : (filterParcelImages === 'WITHOUT' ? 'fa-eye-slash' : 'fa-boxes-stacked')"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Inviato in Axylog</label>
                                    <div class="filter-input-wrapper damaged-filter-wrapper">
                                        <i class="fas fa-cloud-upload-alt filter-icon"></i>
                                        <span class="damaged-filter-text" [class.active]="filterAxylogSent !== 'ALL'">
                                            {{ axylogSentOption.label }}
                                        </span>
                                        <!-- Toggle a 3 posizioni: tutte / inviate / non inviate -->
                                        <button type="button" class="tri-switch"
                                                aria-label="Filtro inviato in Axylog"
                                                [attr.data-pos]="axylogSentOption.pos"
                                                (click)="cycleFilterAxylogSent()"
                                                [title]="axylogSentOption.label + ' (clicca per cambiare)'">
                                            <span class="tri-switch-knob">
                                                <i class="fas" [ngClass]="axylogSentOption.icon"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Colli in Misrouting</label>
                                    <div class="filter-input-wrapper damaged-filter-wrapper misrouting-filter">
                                        <i class="fas fa-shuffle filter-icon"></i>
                                        <span class="damaged-filter-text" [class.active]="filterMisroutingParcels">
                                            {{ filterMisroutingParcels ? 'Solo colli in misrouting' : 'Tutti i colli' }}
                                        </span>
                                        <button type="button" class="damaged-filter-switch"
                                                role="switch" [attr.aria-checked]="filterMisroutingParcels"
                                                [class.active]="filterMisroutingParcels"
                                                (click)="setFilterMisroutingParcels(!filterMisroutingParcels)"
                                                [title]="filterMisroutingParcels ? 'Solo colli in misrouting' : 'Tutti i colli'">
                                            <span class="damaged-filter-switch-knob">
                                                <i class="fas" [ngClass]="filterMisroutingParcels ? 'fa-shuffle' : 'fa-box'"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Filtri salvati dall'utente: una card per insieme di filtri, click per riapplicarli -->
                <div class="saved-searches mt-4 pt-3 border-top" *ngIf="savedSearches.length > 0">
                    <div class="saved-searches-header">
                        <div class="saved-searches-title">
                            <span class="saved-searches-title-icon">
                                <i class="fas fa-bookmark"></i>
                            </span>
                            <div class="saved-searches-title-text">
                                <h6>Filtri salvati</h6>
                                <p>Clicca una card per riapplicare i filtri, poi premi Cerca. Con la matita dai un nome alla card</p>
                            </div>
                            <span class="saved-searches-badge">{{ savedSearches.length }}</span>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-danger"
                                (click)="clearSavedSearches()"
                                title="Elimina tutti i filtri salvati">
                            <i class="fas fa-trash me-1"></i>
                            Elimina tutti
                        </button>
                    </div>
                    <div class="saved-searches-list">
                        <div class="saved-search-card" *ngFor="let search of savedSearches"
                             (click)="applySavedSearch(search)"
                             title="Clicca per applicare questi filtri">
                            <div class="saved-search-icon">
                                <i class="fas fa-bookmark"></i>
                            </div>
                            <div class="saved-search-body">
                                <div class="saved-search-name" [title]="savedSearchDisplayName(search)">
                                    {{ savedSearchDisplayName(search) }}
                                </div>
                                <div class="saved-search-meta">
                                    <span class="saved-search-count">
                                        {{ search.filters.length }} {{ search.filters.length === 1 ? 'filtro' : 'filtri' }}
                                    </span>
                                    <span class="saved-search-date">
                                        <i class="fas fa-clock"></i>
                                        {{ formatSavedSearchDate(search.timestamp) }}
                                    </span>
                                </div>
                            </div>
                            <div class="saved-search-actions">
                                <button type="button" class="saved-search-action-btn"
                                        (click)="openSavedSearchDetails(search); $event.stopPropagation()"
                                        title="Mostra tutti i filtri">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button type="button" class="saved-search-action-btn"
                                        (click)="openRenameSavedSearch(search, $event)"
                                        title="Dai un nome a questi filtri">
                                    <i class="fas fa-pen"></i>
                                </button>
                                <button type="button" class="saved-search-action-btn is-danger"
                                        (click)="removeSavedSearch(search, $event)"
                                        title="Elimina questi filtri salvati">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Azioni -->
                <div class="mt-4 pt-3 border-top">
                    <div class="d-flex justify-content-end align-items-center">
                        <div class="d-flex gap-2">
                            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="resetFilters()"
                                    [title]="'SHIPMENT_MANAGEMENT.RESET_FILTERS' | translate">
                                <i class="fas fa-undo me-1"></i>
                                {{ 'SHIPMENT_MANAGEMENT.RESET_FILTERS' | translate }}
                            </button>
                            <button class="btn btn-outline-primary btn-sm" type="button" (click)="saveCurrentSearch()"
                                    title="Salva i filtri impostati per riutilizzarli in seguito (il nome si assegna dopo, dalla card)">
                                <i class="fas fa-bookmark me-1"></i>
                                Salva filtri
                            </button>
                            <button class="btn btn-primary btn-sm" type="button" (click)="searchWaybills()"
                                    [disabled]="isSearchLoading || isAdvancedSearchLoading"
                                    [title]="!isAdvancedFiltersCollapsed ? ('SHIPMENT_MANAGEMENT.ADVANCED_SEARCH' | translate) : ('SHIPMENT_MANAGEMENT.SEARCH' | translate)">
                                <i class="fas"
                                   [ngClass]="{
                     'fa-spinner fa-spin': !isAdvancedFiltersCollapsed ? isAdvancedSearchLoading : isSearchLoading,
                     'fa-search': !(!isAdvancedFiltersCollapsed ? isAdvancedSearchLoading : isSearchLoading)
                   }"
                                   [class.me-1]="true"></i>
                                {{ !isAdvancedFiltersCollapsed ? ('SHIPMENT_MANAGEMENT.ADVANCED_SEARCH' | translate) : ('SHIPMENT_MANAGEMENT.SEARCH' | translate) }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Sezione Resoconto -->
        <div id="summary-section" class="card mb-4">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="header-title">
                        <i class="fas fa-chart-bar header-icon"></i>
                        <h3>Resoconto</h3>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="toggleReportCollapsed()"
                            [title]="isReportCollapsed ? ('COMMON.EXPAND' | translate) : ('COMMON.COLLAPSE' | translate)">
                        <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                    </button>
                </div>
            </div>
            <div class="card-body" *ngIf="!isReportCollapsed">
                <div class="sm-metrics-grid">

                    <!-- Numero Bolle -->
                    <div class="sm-metric-card">
                        <div class="sm-metric-icon sm-metric-icon--blue">
                            <i class="fas fa-file-alt"></i>
                        </div>
                        <div class="sm-metric-body">
                            <div class="sm-metric-value">
                                <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
                                <ng-container *ngIf="!isLoadingSummaryReport">{{ summaryReport.totalWaybills | number }}</ng-container>
                            </div>
                            <div class="sm-metric-label">Numero Bolle</div>
                        </div>
                    </div>

                    <!-- Numero Colli -->
                    <div class="sm-metric-card">
                        <div class="sm-metric-icon sm-metric-icon--green">
                            <i class="fas fa-cube"></i>
                        </div>
                        <div class="sm-metric-body">
                            <div class="sm-metric-value">
                                <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
                                <ng-container *ngIf="!isLoadingSummaryReport">{{ summaryReport.totalParcels | number }}</ng-container>
                            </div>
                            <div class="sm-metric-label">Numero Colli</div>
                        </div>
                    </div>

                    <!-- Numero Dealers -->
                    <div class="sm-metric-card">
                        <div class="sm-metric-icon sm-metric-icon--purple">
                            <i class="fas fa-store"></i>
                        </div>
                        <div class="sm-metric-body">
                            <div class="sm-metric-value">
                                <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
                                <ng-container *ngIf="!isLoadingSummaryReport">{{ summaryReport.totalDealers | number }}</ng-container>
                            </div>
                            <div class="sm-metric-label">Numero Dealers</div>
                        </div>
                    </div>

                    <!-- Peso Totale -->
                    <div class="sm-metric-card">
                        <div class="sm-metric-icon sm-metric-icon--orange">
                            <i class="fas fa-weight"></i>
                        </div>
                        <div class="sm-metric-body">
                            <div class="sm-metric-value">
                                <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
                                <ng-container *ngIf="!isLoadingSummaryReport">{{ getIntegerPart(summaryReport.totalWeight, '1.3-3') }}<span class="sm-metric-decimals">{{ getDecimalPart(summaryReport.totalWeight, '1.3-3') }}</span></ng-container>
                            </div>
                            <div class="sm-metric-label">Peso Totale (kg)</div>
                        </div>
                    </div>

                    <!-- Volume Totale -->
                    <div class="sm-metric-card">
                        <div class="sm-metric-icon sm-metric-icon--yellow">
                            <i class="fas fa-expand-arrows-alt"></i>
                        </div>
                        <div class="sm-metric-body">
                            <div class="sm-metric-value">
                                <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
                                <ng-container *ngIf="!isLoadingSummaryReport">{{ getIntegerPart(summaryReport.totalVolume, '1.4-4') }}<span class="sm-metric-decimals">{{ getDecimalPart(summaryReport.totalVolume, '1.4-4') }}</span></ng-container>
                            </div>
                            <div class="sm-metric-label">Volume Totale (m³)</div>
                        </div>
                    </div>

                    <!-- Numero Instradamenti -->
                    <div class="sm-metric-card">
                        <div class="sm-metric-icon sm-metric-icon--red">
                            <i class="fas fa-route"></i>
                        </div>
                        <div class="sm-metric-body">
                            <div class="sm-metric-value">
                                <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummaryReport"></span>
                                <ng-container *ngIf="!isLoadingSummaryReport">{{ summaryReport.totalRoutings | number }}</ng-container>
                            </div>
                            <div class="sm-metric-label">Numero Instradamenti</div>
                        </div>
                        <!-- Print Tour Button -->
                        <button type="button"
                                class="sm-metric-action"
                                (click)="printTour()"
                                title="Stampa Tour Completo">
                            <i class="fas fa-print"></i>
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <!-- Tabella Lettere di Vettura PENDING -->
        <div id="results-table" class="card mb-4">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <!-- Titolo e ricerca a sinistra -->
                    <div class="d-flex align-items-center gap-3">
                        <div id="results-table-title" class="header-title">
                            <i class="fas fa-list header-icon"></i>
                            <h3>{{ 'SHIPMENT_MANAGEMENT.PENDING_AND_UNSENT_WAYBILLS' | translate }}</h3>
                        </div>
                    </div>

                    <!-- Controlli a destra -->
                    <div class="controls-container">

                        <!-- Invalida per Borderò -->
                        <button type="button" class="header-action-btn me-1"
                                (click)="invalidateSelectedParcelsForLoadingLists()"
                                [disabled]="isInvalidating || !isSelectionModeActive || selectedParcelCodes.size === 0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Invalida nei Borderò">
                            <i class="fas text-danger"
                               [class.fa-ban]="!isInvalidating"
                               [class.fa-spinner]="isInvalidating"
                               [class.fa-spin]="isInvalidating"></i>
                        </button>

                        <!-- PDF -->
                        <button type="button" class="header-action-btn me-1"
                                (click)="printSelectedPDF()"
                                [disabled]="isPrintingPDF || !isSelectionModeActive || selectedWaybillCodes.size === 0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Stampa PDF">
                            <i class="fas text-danger"
                               [class.fa-file-pdf]="!isPrintingPDF"
                               [class.fa-spinner]="isPrintingPDF"
                               [class.fa-spin]="isPrintingPDF"></i>
                        </button>

                        <!-- Axylog -->
                        <button type="button" class="header-action-btn me-1"
                                (click)="sendToAxylog()"
                                [disabled]="isSendingAxylog || !isSelectionModeActive || selectedWaybillCodes.size === 0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Invia in Axylog">
                            <i class="fas text-primary"
                               [class.fa-cloud-upload-alt]="!isSendingAxylog"
                               [class.fa-spinner]="isSendingAxylog"
                               [class.fa-spin]="isSendingAxylog"></i>
                        </button>

                        <!-- Email -->
                        <button type="button" class="header-action-btn me-1"
                                (click)="sendByMail()"
                                [disabled]="isSendingEmail || !isSelectionModeActive || selectedWaybillCodes.size === 0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Invia per Email">
                            <i class="fas text-primary"
                               [class.fa-envelope]="!isSendingEmail"
                               [class.fa-spinner]="isSendingEmail"
                               [class.fa-spin]="isSendingEmail"></i>
                        </button>

                        <!-- Excel -->
                        <button type="button" class="header-action-btn me-1"
                                (click)="exportToXLSX()"
                                [disabled]="isExporting || (showParcelsView ? filteredParcels.length === 0 : filteredWaybills.length === 0)"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Scarica Excel">
                            <i class="fas text-success"
                               [class.fa-file-excel]="!isExporting"
                               [class.fa-spinner]="isExporting"
                               [class.fa-spin]="isExporting"></i>
                        </button>

                        <!-- Gestione colonne: visibilità e posizione (Bolle / Colli) -->
                        <div class="columns-panel-wrapper me-1">
                            <button type="button" class="header-action-btn columns-panel-toggle"
                                    [class.active]="isColumnsPanelOpen || isColumnLayoutCustomized"
                                    (click)="toggleColumnsPanel()"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    title="Colonne: mostra/nascondi e ordina">
                                <i class="fas fa-columns"></i>
                                <span class="columns-panel-badge" *ngIf="hiddenColumns.size > 0">{{ hiddenColumns.size }}</span>
                            </button>
                            <div class="toolbox-dropdown-backdrop" *ngIf="isColumnsPanelOpen"
                                 (click)="isColumnsPanelOpen = false"></div>
                            <div class="columns-panel" *ngIf="isColumnsPanelOpen" (click)="$event.stopPropagation()">
                                <div class="columns-panel-header">
                                    <div class="columns-panel-title">
                                        <i class="fas fa-columns"></i>
                                        <span>Colonne {{ showParcelsView ? 'Colli' : 'Bolle' }}</span>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-link p-0"
                                            (click)="resetColumnLayout()"
                                            [disabled]="!isColumnLayoutCustomized">
                                        Ripristina
                                    </button>
                                </div>
                                <div class="columns-panel-hint">
                                    Spunta per mostrare/nascondere, trascina o usa le frecce per cambiare posizione.
                                </div>
                                <ul class="columns-panel-list">
                                    <li class="columns-panel-item"
                                        *ngFor="let col of orderedColumnOptions; let idx = index; let first = first; let last = last"
                                        [class.hidden-col]="!isColumnVisible(col.key)"
                                        [class.dragging]="draggedColumnKey === col.key"
                                        [class.drop-target]="dragOverColumnKey === col.key"
                                        draggable="true"
                                        (dragstart)="onColumnDragStart($event, col.key)"
                                        (dragover)="onColumnDragOver($event, col.key)"
                                        (dragleave)="onColumnDragLeave(col.key)"
                                        (drop)="onColumnDrop($event, col.key)"
                                        (dragend)="onColumnDragEnd()">
                                        <i class="fas fa-grip-vertical columns-panel-grip" title="Trascina per spostare"></i>
                                        <span class="columns-panel-pos">{{ idx + 1 }}</span>
                                        <label class="columns-panel-label">
                                            <input type="checkbox" class="form-check-input"
                                                   [checked]="isColumnVisible(col.key)"
                                                   (change)="toggleColumnVisibility(col.key)">
                                            <span>{{ getColumnLabel(col) }}</span>
                                        </label>
                                        <span class="columns-panel-move">
                                            <button type="button" class="columns-panel-move-btn"
                                                    (click)="moveColumn(col.key, -1)" [disabled]="first"
                                                    title="Sposta a sinistra">
                                                <i class="fas fa-chevron-up"></i>
                                            </button>
                                            <button type="button" class="columns-panel-move-btn"
                                                    (click)="moveColumn(col.key, 1)" [disabled]="last"
                                                    title="Sposta a destra">
                                                <i class="fas fa-chevron-down"></i>
                                            </button>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- View Mode Toggle (Bolle/Colli/Instradamenti) -->
                        <div class="btn-group btn-group-sm" role="group">
                            <button type="button" class="btn btn-sm"
                                    [ngClass]="(!showParcelsView && !showRoutingView) ? 'btn-primary' : 'btn-outline-primary'"
                                    [title]="'SHIPMENT_MANAGEMENT.VIEW_BY_WAYBILL' | translate" (click)="showWaybillsView()">
                                <i class="fas fa-file-alt me-1"></i>
                                {{ 'SHIPMENT_MANAGEMENT.WAYBILLS' | translate }}
                            </button>
                            <button type="button" class="btn btn-sm"
                                    [ngClass]="showParcelsView ? 'btn-primary' : 'btn-outline-primary'"
                                    [title]="'SHIPMENT_MANAGEMENT.VIEW_BY_PARCEL' | translate" (click)="showParcelsViewMode()">
                                <i class="fas fa-cube me-1"></i>
                                {{ 'SHIPMENT_MANAGEMENT.COLLI' | translate }}
                            </button>
                            <!-- Pulsante Instradamenti disabilitato temporaneamente
                            <button type="button" class="btn btn-sm"
                                    [ngClass]="showRoutingView ? 'btn-primary' : 'btn-outline-primary'"
                                    title="Visualizza per instradamento" (click)="showRoutingViewMode()">
                                <i class="fas fa-route me-1"></i>
                                Instradamenti
                            </button>
                            -->
                        </div>

                        <!-- Items per page selector -->
                        <div class="btn-group btn-group-sm pagination-selector" role="group">
                            <button type="button" class="btn"
                                    [ngClass]="itemsPerPage === 5 ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setItemsPerPage(5)"
                                    [title]="'5 ' + ('SHIPMENT_MANAGEMENT.ITEMS_PER_PAGE' | translate)">
                                5
                            </button>
                            <button type="button" class="btn"
                                    [ngClass]="itemsPerPage === 10 ? 'btn-secondary' : 'btn-outline-secondary'"
                                    (click)="setItemsPerPage(10)" [title]="'10 ' + ('SHIPMENT_MANAGEMENT.ITEMS_PER_PAGE' | translate)">
                                10
                            </button>
                            <button type="button" class="btn"
                                    [ngClass]="itemsPerPage === 25 ? 'btn-secondary' : 'btn-outline-secondary'"
                                    (click)="setItemsPerPage(25)" [title]="'25 ' + ('SHIPMENT_MANAGEMENT.ITEMS_PER_PAGE' | translate)">
                                25
                            </button>
                            <button type="button" class="btn"
                                    [ngClass]="itemsPerPage === 50 ? 'btn-secondary' : 'btn-outline-secondary'"
                                    (click)="setItemsPerPage(50)" [title]="'50 ' + ('SHIPMENT_MANAGEMENT.ITEMS_PER_PAGE' | translate)">
                                50
                            </button>
                            <button type="button" class="btn"
                                    [ngClass]="itemsPerPage === 100 ? 'btn-secondary' : 'btn-outline-secondary'"
                                    (click)="setItemsPerPage(100)" [title]="'100 ' + ('SHIPMENT_MANAGEMENT.ITEMS_PER_PAGE' | translate)">
                                100
                            </button>
                        </div>

                        <!-- Counter Badge -->
                        <div class="counter-display">
              <span class="badge bg-light text-muted">
                <i class="fas me-1" [ngClass]="showRoutingView ? 'fa-route' : (showParcelsView ? 'fa-boxes' : 'fa-file-alt')"></i>
                  {{ currentResultCount | number }}
              </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body p-0 results-table-body" [class.table-compact]="isCompactTable">

                <!-- Overlay di caricamento (solo su dati già presenti nella vista corrente) -->
                <div class="table-loading-overlay" *ngIf="isLoading && currentPageItemsCount > 0">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
                    </div>
                </div>

                <!-- Tabella Waybills (Vista default) -->
                <div *ngIf="!showParcelsView && !showRoutingView && filteredWaybills.length > 0" class="sm-table-outer">
                <div #waybillsScroll class="table-responsive sm-data-table-wrapper" (scroll)="waybillsHScrollCtl.syncFromTable()">
                    <table class="table table-hover mb-0 sm-data-table">
                        <thead>
                        <tr>
                            <th class="pt-col-check text-center">
                                <input type="checkbox" class="form-check-input"
                                       [checked]="areAllWaybillsSelected()"
                                       (change)="areAllWaybillsSelected() ? deselectAllWaybills() : selectAllWaybills()"
                                       title="Seleziona/Deseleziona tutto">
                            </th>
                            <th class="pt-col-index">#</th>
                            <th class="sortable-header" (click)="sortBy('waybillCode')"
                                [title]="'SHIPMENT_MANAGEMENT.SORT_TOOLTIP' | translate">
                                {{ 'SHIPMENT_MANAGEMENT.WAYBILL_CODE' | translate }}
                                <i [class]="getSortIcon('waybillCode')"></i>
                            </th>

                            <!-- Colonne configurabili: ordine e visibilità gestiti dall'utente, trascinabili -->
                            <th *ngFor="let col of visibleOrderedColumns"
                                [ngClass]="col.responsive || ''"
                                [class.sortable-header]="col.sortable !== false"
                                [class.pt-col-num]="col.align === 'num'"
                                [class.text-center]="col.align === 'center'"
                                [class.pt-col-icon]="col.align === 'center'"
                                [class.pt-th-dragging]="draggedColumnKey === col.key"
                                [class.pt-th-drop-target]="dragOverColumnKey === col.key"
                                draggable="true"
                                (dragstart)="onColumnDragStart($event, col.key)"
                                (dragover)="onColumnDragOver($event, col.key)"
                                (dragleave)="onColumnDragLeave(col.key)"
                                (drop)="onColumnDrop($event, col.key)"
                                (dragend)="onColumnDragEnd()"
                                (click)="col.sortable !== false && sortBy(col.key)"
                                [title]="col.sortable !== false ? ('SHIPMENT_MANAGEMENT.SORT_TOOLTIP' | translate) : ''">
                                <span class="pt-th-content">
                                    <i class="fas fa-grip-vertical pt-drag-handle" title="Trascina per spostare la colonna"></i>
                                    {{ getColumnLabel(col) }}
                                    <i *ngIf="col.sortable !== false" [class]="getSortIcon(col.key)"></i>
                                </span>
                            </th>

                            <th class="pt-col-actions">{{ 'SHIPMENT_MANAGEMENT.ACTIONS' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let waybill of filteredWaybills; let i = index"
                            [class.table-active]="selectedWaybill?.waybillId === waybill.waybillId">
                            <td class="text-center">
                                <input type="checkbox" class="form-check-input"
                                       [checked]="isWaybillSelected(waybill.waybillCode)"
                                       (change)="toggleWaybillSelection(waybill.waybillCode)"
                                       [title]="'Seleziona bolla: ' + waybill.waybillCode">
                            </td>
                            <td class="pt-index">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>

                            <!-- Codice bolla -->
                            <td>
                                <div class="pt-cell">
                                    <span class="clickable-code pt-code"
                                          (click)="openDetailPopup('waybill', waybill.waybillCode)"
                                          [title]="'Clicca per vedere i dettagli del codice bolla: ' + waybill.waybillCode">
                                        {{ waybill.waybillCode }}
                                    </span>
                                    <i class="fas fa-copy copy-icon"
                                       (click)="$event.stopPropagation(); copyToClipboard(waybill.waybillCode, 'waybill')"
                                       [title]="'Copia codice bolla: ' + waybill.waybillCode"></i>
                                </div>
                            </td>

                            <!-- Colonne configurabili -->
                            <td *ngFor="let col of visibleOrderedColumns"
                                [ngClass]="col.responsive || ''"
                                [class.pt-col-num]="col.align === 'num'"
                                [class.text-center]="col.align === 'center'"
                                [class.pt-td-drop-target]="dragOverColumnKey === col.key"
                                [ngSwitch]="col.key">

                                <!-- Cliente: acronimo, stesso stile del codice bolla -->
                                <ng-container *ngSwitchCase="'waybillClientCode'">
                                    <div class="pt-cell" *ngIf="waybill.waybillClientCode; else noWaybillClient">
                                        <span class="clickable-code pt-code pt-text"
                                              (click)="openClientDetailPopup(waybill.waybillClientCode)"
                                              [title]="'Clicca per vedere i dettagli del cliente: ' + waybill.waybillClientCode">
                                            {{ getClientNameByCode(waybill.waybillClientCode) }}
                                        </span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(getClientNameByCode(waybill.waybillClientCode), 'Cliente')"
                                           [title]="'Copia cliente: ' + getClientNameByCode(waybill.waybillClientCode)"></i>
                                    </div>
                                    <ng-template #noWaybillClient><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Data bolla -->
                                <ng-container *ngSwitchCase="'waybillDate'">
                                    <div class="pt-cell" *ngIf="waybill.waybillDate; else noDateInfo">
                                        <span class="pt-date">{{ waybill.waybillDate | date:'dd/MM/yy HH:mm' }}</span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatDateForCopy(waybill.waybillDate), 'Data Bolla')"
                                           [title]="'Copia data bolla: ' + (waybill.waybillDate | date:'dd/MM/yy HH:mm')"></i>
                                    </div>
                                    <ng-template #noDateInfo><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Stima consegna -->
                                <ng-container *ngSwitchCase="'waybillEstimatedDeliveryDate'">
                                    <div class="pt-cell" *ngIf="waybill.waybillEstimatedDeliveryDate; else noEstimatedDate">
                                        <span class="pt-date">{{ waybill.waybillEstimatedDeliveryDate | date:'dd/MM/yy HH:mm' }}</span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatDateForCopy(waybill.waybillEstimatedDeliveryDate), 'Stima Consegna')"
                                           [title]="'Copia stima consegna: ' + (waybill.waybillEstimatedDeliveryDate | date:'dd/MM/yy HH:mm')"></i>
                                    </div>
                                    <ng-template #noEstimatedDate><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Data consegna -->
                                <ng-container *ngSwitchCase="'waybillActualDeliveryDate'">
                                    <div class="pt-cell" *ngIf="waybill.waybillActualDeliveryDate; else noActualDate">
                                        <span class="pt-date">{{ waybill.waybillActualDeliveryDate | date:'dd/MM/yy HH:mm' }}</span>
                                        <ng-container *ngTemplateOutlet="deliveryPunctuality; context: { actual: waybill.waybillActualDeliveryDate, estimated: waybill.waybillEstimatedDeliveryDate }"></ng-container>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatDateForCopy(waybill.waybillActualDeliveryDate), 'Data Consegna')"
                                           [title]="'Copia data consegna: ' + (waybill.waybillActualDeliveryDate | date:'dd/MM/yy HH:mm')"></i>
                                    </div>
                                    <ng-template #noActualDate>
                                        <span class="pt-unassigned" title="Non ancora consegnato">
                                            <i class="fas fa-calendar-xmark"></i> Non Consegnato
                                        </span>
                                    </ng-template>
                                </ng-container>

                                <!-- Instradamento -->
                                <ng-container *ngSwitchCase="'waybillDeliveryType'">
                                    <div class="pt-cell" *ngIf="waybill.waybillDeliveryType; else unassigned">
                                        <span class="pt-code pt-code--plain">{{ waybill.waybillDeliveryType }}</span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(waybill.waybillDeliveryType || '', 'instradamento')"
                                           [title]="'Copia instradamento: ' + (waybill.waybillDeliveryType || '')"></i>
                                    </div>
                                    <ng-template #unassigned>
                                        <button type="button" class="pt-unassigned pt-unassigned--btn"
                                                (click)="$event.stopPropagation(); onClickAssignCarrier(waybill)"
                                                title="Instradamento da assegnare: clicca per completare la bolla">
                                            <i class="fas fa-exclamation-circle"></i> Da Assegnare
                                        </button>
                                    </ng-template>
                                </ng-container>

                                <!-- Vettore Ultimo Miglio: nome vettore, click apre il popup dettagli -->
                                <ng-container *ngSwitchCase="'waybillCarrierName'">
                                    <div class="pt-cell" *ngIf="waybill.waybillCarrierCode; else noCarrierCode">
                                        <span class="clickable-code pt-code pt-text"
                                              (click)="$event.stopPropagation(); openCarrierDetailPopup(waybill.waybillCarrierCode)"
                                              [title]="'Clicca per vedere i dettagli del vettore: ' + (waybill.waybillCarrierName || waybill.waybillCarrierCode)">
                                            {{ waybill.waybillCarrierName || waybill.waybillCarrierCode }}
                                        </span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(waybill.waybillCarrierName || waybill.waybillCarrierCode || '', 'vettore ultimo miglio')"
                                           [title]="'Copia vettore: ' + (waybill.waybillCarrierName || waybill.waybillCarrierCode)"></i>
                                    </div>
                                    <ng-template #noCarrierCode>
                                        <button type="button" class="pt-unassigned pt-unassigned--btn"
                                                (click)="$event.stopPropagation(); onClickAssignCarrier(waybill)"
                                                title="Vettore ultimo miglio da assegnare: clicca per completare la bolla">
                                            <i class="fas fa-exclamation-circle"></i> Da Assegnare
                                        </button>
                                    </ng-template>
                                </ng-container>

                                <!-- Ragione sociale -->
                                <ng-container *ngSwitchCase="'companyName'">
                                    <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noDealerInfo">
                                        <div class="pt-cell">
                                            <span class="clickable-code pt-code pt-text"
                                                  (click)="openDealerDetailPopup(dealer.dealerCode)"
                                                  [title]="'Clicca per vedere i dettagli del dealer: ' + (dealer.dealerName || dealer.dealerLegalName || '')">
                                                {{ dealer.dealerName || dealer.dealerLegalName || '-' }}
                                            </span>
                                            <i class="fas fa-copy copy-icon"
                                               *ngIf="dealer.dealerName || dealer.dealerLegalName"
                                               (click)="$event.stopPropagation(); copyToClipboard(dealer.dealerName || dealer.dealerLegalName || '', 'ragione-sociale')"
                                               [title]="'Copia ragione sociale: ' + (dealer.dealerName || dealer.dealerLegalName || '')"></i>
                                        </div>
                                    </ng-container>
                                    <ng-template #noDealerInfo><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Indirizzo -->
                                <ng-container *ngSwitchCase="'address'">
                                    <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noAddressInfo">
                                        <div class="pt-cell" *ngIf="dealer.dealerOperatingAddressStreet || dealer.dealerOperatingAddressNumber; else noAddressInfo">
                                            <span class="pt-code pt-code--plain pt-text">{{ dealer.dealerOperatingAddressStreet }} {{ dealer.dealerOperatingAddressNumber }}</span>
                                            <i class="fas fa-copy copy-icon"
                                               (click)="$event.stopPropagation(); copyToClipboard(((dealer.dealerOperatingAddressStreet || '') + ' ' + (dealer.dealerOperatingAddressNumber || '')).trim(), 'Indirizzo')"
                                               [title]="'Copia indirizzo: ' + (dealer.dealerOperatingAddressStreet || '') + ' ' + (dealer.dealerOperatingAddressNumber || '')"></i>
                                        </div>
                                    </ng-container>
                                    <ng-template #noAddressInfo><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Città -->
                                <ng-container *ngSwitchCase="'city'">
                                    <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noCityInfo">
                                        <div class="pt-cell" *ngIf="dealer.dealerOperatingAddressCity; else noCityInfo">
                                            <span class="pt-code pt-code--plain pt-text">{{ dealer.dealerOperatingAddressCity }}</span>
                                            <i class="fas fa-copy copy-icon"
                                               (click)="$event.stopPropagation(); copyToClipboard(dealer.dealerOperatingAddressCity || '', 'Città')"
                                               [title]="'Copia città: ' + dealer.dealerOperatingAddressCity"></i>
                                        </div>
                                    </ng-container>
                                    <ng-template #noCityInfo><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Provincia -->
                                <ng-container *ngSwitchCase="'province'">
                                    <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noProvinceInfo">
                                        <div class="pt-cell" *ngIf="dealer.dealerOperatingAddressProvince; else noProvinceInfo">
                                            <span class="pt-code pt-code--plain">{{ dealer.dealerOperatingAddressProvince }}</span>
                                            <i class="fas fa-copy copy-icon"
                                               (click)="$event.stopPropagation(); copyToClipboard(dealer.dealerOperatingAddressProvince || '', 'Provincia')"
                                               [title]="'Copia provincia: ' + dealer.dealerOperatingAddressProvince"></i>
                                        </div>
                                    </ng-container>
                                    <ng-template #noProvinceInfo><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Numero colli -->
                                <ng-container *ngSwitchCase="'parcelsCount'">
                                    <div class="pt-cell pt-cell--num">
                                        <span class="parcel-count">{{ getParcelsCountForWaybill(waybill.waybillCode) }}</span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard('' + getParcelsCountForWaybill(waybill.waybillCode), 'Numero Colli')"
                                           [title]="'Copia numero colli: ' + getParcelsCountForWaybill(waybill.waybillCode)"></i>
                                    </div>
                                </ng-container>

                                <!-- Stato -->
                                <ng-container *ngSwitchCase="'waybillStatus'">
                                    <div class="pt-cell">
                                        <span class="pt-type"
                                              [ngClass]="'pt-type--' + getWaybillStatusStyle(waybill.waybillStatus).variant">
                                            <i class="fas" [ngClass]="getWaybillStatusStyle(waybill.waybillStatus).icon"></i>
                                            {{ getParcelStatusText(waybill.waybillStatus) | translate }}
                                        </span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(getWaybillStatusLabelForCopy(waybill.waybillStatus), 'Stato')"
                                           [title]="'Copia stato: ' + (getParcelStatusText(waybill.waybillStatus) | translate)"></i>
                                    </div>
                                </ng-container>

                                <!-- Download -->
                                <ng-container *ngSwitchCase="'download'">
                                    <button type="button" class="pt-action-btn pt-action-btn--pdf"
                                            (click)="downloadWaybillDocument(waybill.waybillId)"
                                            [title]="'SHIPMENT_MANAGEMENT.DOWNLOAD' | translate">
                                        <i class="fas fa-file-pdf"></i>
                                    </button>
                                </ng-container>

                                <!-- POD -->
                                <ng-container *ngSwitchCase="'pod'">
                                    <button type="button" class="pt-action-btn pt-action-btn--pod"
                                            (click)="downloadPodDocument(waybill.waybillId)"
                                            [disabled]="waybill.waybillStatus !== 'DELIVERED'"
                                            [title]="'SHIPMENT_MANAGEMENT.POD' | translate">
                                        <i class="fas fa-file-pdf"></i>
                                    </button>
                                </ng-container>
                            </td>

                            <!-- Azioni -->
                            <td class="pt-col-actions">
                                <div class="pt-actions">
                                    <button type="button" class="pt-action-btn pt-action-btn--dealer"
                                            [disabled]="!(waybill.waybillStatus === 'PENDING' && !waybill.waybillDealerCode && waybill.waybillAddressAlias)"
                                            (click)="openDealerAssignmentPopup(waybill)"
                                            [title]="'SHIPMENT_MANAGEMENT.ASSIGN_DEALER' | translate">
                                        <i class="fas fa-store"></i>
                                    </button>

                                    <button type="button" class="pt-action-btn pt-action-btn--carrier"
                                            [disabled]="!((waybill.waybillStatus === 'PENDING' || waybill.waybillStatus === 'UNSENT') && !!waybill.waybillDealerCode)"
                                            (click)="onClickAssignCarrier(waybill)"
                                            [title]="'SHIPMENT_MANAGEMENT.ASSIGN_CARRIER' | translate">
                                        <i class="fas fa-truck"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Sentinella: quando la fine della tabella è visibile la barra flottante sparisce -->
                <div #waybillsEndSentinel class="sm-table-end-sentinel"></div>

                <!-- Barra di scorrimento orizzontale flottante: sticky al bordo inferiore dello schermo,
                     confinata all'area della tabella, visibile solo con almeno 25 righe e overflow orizzontale -->
                <!-- Barra flottante disabilitata temporaneamente
                <div class="sm-floating-hscroll" [hidden]="!showWaybillsFloatingScrollbar">
                    <div class="sm-floating-hscroll-label" title="Scorrimento orizzontale della tabella">
                        <i class="fas fa-arrows-alt-h"></i>
                        <span>Scorri</span>
                    </div>
                    <div #waybillsHScroll class="sm-floating-hscroll-track"
                         (scroll)="waybillsHScrollCtl.syncFromBar()">
                        <div class="sm-floating-hscroll-inner" [style.width.px]="waybillsHScrollCtl.innerWidth"></div>
                    </div>
                </div>
                -->
                </div>

                <!-- Tabella Parcels (Vista Colli) -->
                <div *ngIf="showParcelsView && filteredParcels.length > 0" class="sm-table-outer">
                <div #parcelsScroll class="table-responsive sm-data-table-wrapper" (scroll)="parcelsHScrollCtl.syncFromTable()">
                    <table class="table table-hover mb-0 sm-data-table">
                        <thead>
                        <tr>
                            <th class="pt-col-check text-center">
                                <input type="checkbox" class="form-check-input"
                                       [checked]="areAllParcelsSelected()"
                                       (change)="areAllParcelsSelected() ? deselectAllParcels() : selectAllParcels()"
                                       title="Seleziona/Deseleziona tutto">
                            </th>
                            <th class="pt-col-index">#</th>
                            <th class="sortable-header" (click)="sortBy('parcelCode')"
                                [title]="'SHIPMENT_MANAGEMENT.SORT_TOOLTIP' | translate">
                                {{ 'SHIPMENT_MANAGEMENT.PARCEL_CODE' | translate }}
                                <i [class]="getSortIcon('parcelCode')"></i>
                            </th>
                            <th class="sortable-header" (click)="sortBy('parcelWaybillCode')"
                                [title]="'SHIPMENT_MANAGEMENT.SORT_TOOLTIP' | translate">
                                {{ 'SHIPMENT_MANAGEMENT.WAYBILL_CODE' | translate }}
                                <i [class]="getSortIcon('parcelWaybillCode')"></i>
                            </th>
                            <th class="sortable-header" *ngIf="hasOriginalWaybillCodes" (click)="sortBy('parcelOriginalWaybillCode')"
                                [title]="'SHIPMENT_MANAGEMENT.SORT_TOOLTIP' | translate">
                                {{ 'SHIPMENT_MANAGEMENT.ORIGINAL_WAYBILL_CODE' | translate }}
                                <i [class]="getSortIcon('parcelOriginalWaybillCode')"></i>
                            </th>

                            <!-- Colonne configurabili: ordine e visibilità gestiti dall'utente, trascinabili -->
                            <th *ngFor="let col of visibleOrderedColumns"
                                [ngClass]="col.responsive || ''"
                                [class.sortable-header]="col.sortable !== false"
                                [class.pt-col-num]="col.align === 'num'"
                                [class.text-center]="col.align === 'center'"
                                [class.pt-th-dragging]="draggedColumnKey === col.key"
                                [class.pt-th-drop-target]="dragOverColumnKey === col.key"
                                draggable="true"
                                (dragstart)="onColumnDragStart($event, col.key)"
                                (dragover)="onColumnDragOver($event, col.key)"
                                (dragleave)="onColumnDragLeave(col.key)"
                                (drop)="onColumnDrop($event, col.key)"
                                (dragend)="onColumnDragEnd()"
                                (click)="col.sortable !== false && sortBy(col.key)"
                                [title]="col.sortable !== false ? ('SHIPMENT_MANAGEMENT.SORT_TOOLTIP' | translate) : ''">
                                <span class="pt-th-content">
                                    <i class="fas fa-grip-vertical pt-drag-handle" title="Trascina per spostare la colonna"></i>
                                    {{ getColumnLabel(col) }}
                                    <i *ngIf="col.sortable !== false" [class]="getSortIcon(col.key)"></i>
                                </span>
                            </th>

                            <th class="pt-col-actions">{{ 'SHIPMENT_MANAGEMENT.ACTIONS' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let parcel of filteredParcels; let i = index"
                            [class.table-active]="selectedParcel?.parcelId === parcel.parcelId"
                            [class.pt-row-inactive]="parcel.parcelInactiveForLoadingLists">
                            <td class="text-center">
                                <input type="checkbox" class="form-check-input"
                                       [checked]="isParcelSelected(parcel.parcelCode)"
                                       (change)="toggleParcelSelection(parcel.parcelCode)"
                                       [title]="'Seleziona collo: ' + parcel.parcelCode">
                            </td>
                            <td class="pt-index">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>

                            <!-- Codice collo -->
                            <td>
                                <div class="pt-cell" *ngIf="parcel.parcelCode; else noParcelCode">
                                    <i *ngIf="parcel.parcelInactiveForLoadingLists" class="fas fa-ban text-danger pt-flag"
                                       title="Collo non attivo per le liste di carico"></i>
                                    <span class="clickable-code pt-code"
                                          (click)="openDetailPopup('collo', parcel.parcelCode || '')"
                                          [title]="'Clicca per vedere i dettagli del codice collo: ' + (parcel.parcelCode || '')">
                                        {{ parcel.parcelCode }}
                                    </span>
                                    <span *ngIf="isParcelDamaged(parcel)" class="pt-damaged-badge"
                                          data-tooltip="Collo Danneggiato">D</span>
                                    <span *ngIf="hasParcelMisrouting(parcel)" class="pt-misrouting-badge"
                                          data-tooltip="Collo con Misrouting">M</span>
                                    <i class="fas fa-copy copy-icon"
                                       (click)="$event.stopPropagation(); copyToClipboard(parcel.parcelCode || '', 'collo')"
                                       [title]="'Copia codice collo: ' + (parcel.parcelCode || '')"></i>
                                </div>
                                <ng-template #noParcelCode><span class="pt-empty">-</span></ng-template>
                            </td>

                            <!-- Codice bolla -->
                            <td>
                                <div class="pt-cell" *ngIf="parcel.parcelWaybillCode; else noWaybillCode">
                                    <span class="clickable-code pt-code"
                                          (click)="openDetailPopup('waybill', parcel.parcelWaybillCode || '')"
                                          [title]="'Clicca per vedere i dettagli del codice bolla: ' + (parcel.parcelWaybillCode || '')">
                                        {{ parcel.parcelWaybillCode }}
                                    </span>
                                    <i class="fas fa-copy copy-icon"
                                       (click)="$event.stopPropagation(); copyToClipboard(parcel.parcelWaybillCode || '', 'waybill')"
                                       [title]="'Copia codice bolla: ' + (parcel.parcelWaybillCode || '')"></i>
                                </div>
                                <ng-template #noWaybillCode><span class="pt-empty">-</span></ng-template>
                            </td>

                            <!-- Bolla originale (PARCEL_ORIGINAL_WAYBILL_CODE): colonna presente solo se almeno un collo in elenco l'ha valorizzata -->
                            <td *ngIf="hasOriginalWaybillCodes">
                                <div class="pt-cell" *ngIf="parcel.parcelOriginalWaybillCode; else noOriginalWaybillCode">
                                    <span class="clickable-code pt-code"
                                          (click)="openDetailPopup('waybill', parcel.parcelOriginalWaybillCode || '')"
                                          [title]="'Clicca per vedere i dettagli della bolla originale: ' + (parcel.parcelOriginalWaybillCode || '')">
                                        {{ parcel.parcelOriginalWaybillCode }}
                                    </span>
                                    <i class="fas fa-copy copy-icon"
                                       (click)="$event.stopPropagation(); copyToClipboard(parcel.parcelOriginalWaybillCode || '', 'Codice Bolla Originale')"
                                       [title]="'Copia codice bolla originale: ' + (parcel.parcelOriginalWaybillCode || '')"></i>
                                </div>
                                <ng-template #noOriginalWaybillCode><span class="pt-empty">-</span></ng-template>
                            </td>

                            <!-- Colonne configurabili -->
                            <td *ngFor="let col of visibleOrderedColumns"
                                [ngClass]="col.responsive || ''"
                                [class.pt-col-num]="col.align === 'num'"
                                [class.text-center]="col.align === 'center'"
                                [class.pt-td-drop-target]="dragOverColumnKey === col.key"
                                [ngSwitch]="col.key">

                                <!-- Data collo -->
                                <ng-container *ngSwitchCase="'parcelDate'">
                                    <div class="pt-cell" *ngIf="parcel.parcelDate; else noParcelDateInfo">
                                        <span class="pt-date">{{ parcel.parcelDate | date:'dd/MM/yy HH:mm' }}</span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatDateForCopy(parcel.parcelDate), 'Data Collo')"
                                           [title]="'Copia data collo: ' + (parcel.parcelDate | date:'dd/MM/yy HH:mm')"></i>
                                    </div>
                                    <ng-template #noParcelDateInfo><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Stima consegna -->
                                <ng-container *ngSwitchCase="'parcelEstimatedDeliveryDate'">
                                    <div class="pt-cell" *ngIf="parcel.parcelEstimatedDeliveryDate; else noParcelEstimatedDate">
                                        <span class="pt-date">{{ parcel.parcelEstimatedDeliveryDate | date:'dd/MM/yy HH:mm' }}</span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatDateForCopy(parcel.parcelEstimatedDeliveryDate), 'Stima Consegna')"
                                           [title]="'Copia stima consegna: ' + (parcel.parcelEstimatedDeliveryDate | date:'dd/MM/yy HH:mm')"></i>
                                    </div>
                                    <ng-template #noParcelEstimatedDate><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Data consegna -->
                                <ng-container *ngSwitchCase="'parcelDeliveryDate'">
                                    <div class="pt-cell" *ngIf="parcel.parcelDeliveryDate; else noParcelDeliveryDate">
                                        <span class="pt-date">{{ parcel.parcelDeliveryDate | date:'dd/MM/yy HH:mm' }}</span>
                                        <ng-container *ngTemplateOutlet="deliveryPunctuality; context: { actual: parcel.parcelDeliveryDate, estimated: parcel.parcelEstimatedDeliveryDate }"></ng-container>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatDateForCopy(parcel.parcelDeliveryDate), 'Data Consegna')"
                                           [title]="'Copia data consegna: ' + (parcel.parcelDeliveryDate | date:'dd/MM/yy HH:mm')"></i>
                                    </div>
                                    <ng-template #noParcelDeliveryDate>
                                        <span class="pt-unassigned" title="Non ancora consegnato">
                                            <i class="fas fa-calendar-xmark"></i> Non Consegnato
                                        </span>
                                    </ng-template>
                                </ng-container>

                                <!-- Codice dealer -->
                                <ng-container *ngSwitchCase="'parcelDealerCode'">
                                    <div class="pt-cell" *ngIf="parcel.parcelDealerCode; else noDealerCode">
                                        <span class="pt-code pt-code--plain">{{ parcel.parcelDealerCode }}</span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(parcel.parcelDealerCode || '', 'Codice Dealer')"
                                           [title]="'Copia codice dealer: ' + parcel.parcelDealerCode"></i>
                                    </div>
                                    <ng-template #noDealerCode><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Cliente -->
                                <ng-container *ngSwitchCase="'parcelClientCode'">
                                    <div class="pt-cell" *ngIf="parcel.parcelClientCode; else noClientCode">
                                        <span class="clickable-code pt-code pt-text"
                                              (click)="openClientDetailPopup(parcel.parcelClientCode)"
                                              [title]="'Clicca per vedere i dettagli del cliente: ' + parcel.parcelClientCode">
                                            {{ getClientNameByCode(parcel.parcelClientCode) }}
                                        </span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(getClientNameByCode(parcel.parcelClientCode), 'Cliente')"
                                           [title]="'Copia cliente: ' + getClientNameByCode(parcel.parcelClientCode)"></i>
                                    </div>
                                    <ng-template #noClientCode><span class="pt-empty">-</span></ng-template>
                                </ng-container>

                                <!-- Tipologia collo -->
                                <ng-container *ngSwitchCase="'parcelType'">
                                    <div class="pt-cell">
                                        <span class="pt-type"
                                              [ngClass]="'pt-type--' + getParcelTypeVariant(parcel.parcelType)">
                                            <i class="fas"
                                               [class.fa-bolt]="getParcelTypeVariant(parcel.parcelType) === 'urgent'"
                                               [class.fa-clock]="getParcelTypeVariant(parcel.parcelType) === 'stock'"
                                               [class.fa-tags]="getParcelTypeVariant(parcel.parcelType) === 'promo'"
                                               [class.fa-circle-question]="getParcelTypeVariant(parcel.parcelType) === 'unknown'"></i>
                                            {{ getParcelTypeLabel(parcel.parcelType) }}
                                        </span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(getParcelTypeLabel(parcel.parcelType), 'Tipologia Collo')"
                                           [title]="'Copia tipologia collo: ' + getParcelTypeLabel(parcel.parcelType)"></i>
                                    </div>
                                </ng-container>

                                <!-- Peso -->
                                <ng-container *ngSwitchCase="'parcelWeight'">
                                    <div class="pt-cell pt-cell--num">
                                        <span class="pt-num">{{ (parcel.parcelWeight || 0) | number:'1.2-2' }}<small class="pt-unit">kg</small></span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatNumberForCopy(parcel.parcelWeight, '1.2-2'), 'Peso')"
                                           [title]="'Copia peso: ' + ((parcel.parcelWeight || 0) | number:'1.2-2') + ' kg'"></i>
                                    </div>
                                </ng-container>

                                <!-- Volume -->
                                <ng-container *ngSwitchCase="'parcelVolume'">
                                    <div class="pt-cell pt-cell--num">
                                        <span class="pt-num">{{ (parcel.parcelVolume || 0) | number:'1.4-4' }}<small class="pt-unit">m³</small></span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatNumberForCopy(parcel.parcelVolume, '1.4-4'), 'Volume')"
                                           [title]="'Copia volume: ' + ((parcel.parcelVolume || 0) | number:'1.4-4') + ' m³'"></i>
                                    </div>
                                </ng-container>

                                <!-- Lunghezza -->
                                <ng-container *ngSwitchCase="'parcelLength'">
                                    <div class="pt-cell pt-cell--num">
                                        <span class="pt-num">{{ (parcel.parcelLength || 0) | number:'1.1-1' }}<small class="pt-unit">cm</small></span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatNumberForCopy(parcel.parcelLength, '1.1-1'), 'Lunghezza')"
                                           [title]="'Copia lunghezza: ' + ((parcel.parcelLength || 0) | number:'1.1-1') + ' cm'"></i>
                                    </div>
                                </ng-container>

                                <!-- Larghezza -->
                                <ng-container *ngSwitchCase="'parcelWidth'">
                                    <div class="pt-cell pt-cell--num">
                                        <span class="pt-num">{{ (parcel.parcelWidth || 0) | number:'1.1-1' }}<small class="pt-unit">cm</small></span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatNumberForCopy(parcel.parcelWidth, '1.1-1'), 'Larghezza')"
                                           [title]="'Copia larghezza: ' + ((parcel.parcelWidth || 0) | number:'1.1-1') + ' cm'"></i>
                                    </div>
                                </ng-container>

                                <!-- Altezza -->
                                <ng-container *ngSwitchCase="'parcelHeight'">
                                    <div class="pt-cell pt-cell--num">
                                        <span class="pt-num">{{ (parcel.parcelHeight || 0) | number:'1.1-1' }}<small class="pt-unit">cm</small></span>
                                        <i class="fas fa-copy copy-icon"
                                           (click)="$event.stopPropagation(); copyToClipboard(formatNumberForCopy(parcel.parcelHeight, '1.1-1'), 'Altezza')"
                                           [title]="'Copia altezza: ' + ((parcel.parcelHeight || 0) | number:'1.1-1') + ' cm'"></i>
                                    </div>
                                </ng-container>
                            </td>

                            <!-- Azioni -->
                            <td class="pt-col-actions">
                                <div class="pt-actions">
                                    <!-- Stampa etichetta collo -->
                                    <button type="button" class="pt-action-btn pt-action-btn--label"
                                            (click)="$event.stopPropagation(); printParcelLabel(parcel)"
                                            [disabled]="!parcel.parcelCode || isPrintingParcelLabel(parcel)"
                                            [title]="'Stampa etichetta collo ' + (parcel.parcelCode || '')">
                                        <i class="fas" [ngClass]="isPrintingParcelLabel(parcel) ? 'fa-spinner fa-spin' : 'fa-tag'"></i>
                                    </button>

                                    <button type="button" class="btn btn-sm pt-select-btn"
                                            (click)="selectParcel(parcel)"
                                            [disabled]="parcel.parcelClientCode !== 'CLT00010' || parcel.parcelBrandCode !== 'BRD00004'"
                                            [ngClass]="(parcel.parcelClientCode !== 'CLT00010' || parcel.parcelBrandCode !== 'BRD00004') ? 'btn-outline-success' : 'btn-outline-primary'"
                                            [class.btn-primary]="selectedParcel?.parcelId === parcel.parcelId && (parcel.parcelClientCode === 'CLT00010' && parcel.parcelBrandCode === 'BRD00004')"
                                            [class.btn-success]="parcel.parcelClientCode !== 'CLT00010' || parcel.parcelBrandCode !== 'BRD00004'"
                                            [class.text-white]="selectedParcel?.parcelId === parcel.parcelId"
                                            [title]="selectedParcel?.parcelId === parcel.parcelId ?
                               ('SHIPMENT_MANAGEMENT.EDIT_PARCEL' | translate) :
                               (parcel.parcelClientCode === 'CLT00010' && parcel.parcelBrandCode === 'BRD00004' ?
                               ('SHIPMENT_MANAGEMENT.SELECT_PARCEL' | translate) :
                               ('SHIPMENT_MANAGEMENT.NOT_ELIGIBLE' | translate))">
                                        <i class="fas" [ngClass]="(parcel.parcelClientCode !== 'CLT00010' || parcel.parcelBrandCode !== 'BRD00004') ? 'fa-check-circle' : 'fa-edit'"></i>
                                        {{ selectedParcel?.parcelId === parcel.parcelId ?
                                        ('SHIPMENT_MANAGEMENT.SELECTED' | translate) :
                                        (parcel.parcelClientCode === 'CLT00010' && parcel.parcelBrandCode === 'BRD00004' ?
                                            ('SHIPMENT_MANAGEMENT.SELECT' | translate) : 'Ultimata') }}
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Sentinella: quando la fine della tabella è visibile la barra flottante sparisce -->
                <div #parcelsEndSentinel class="sm-table-end-sentinel"></div>

                <!-- Barra di scorrimento orizzontale flottante della tabella colli -->
                <!-- Barra flottante disabilitata temporaneamente
                <div class="sm-floating-hscroll" [hidden]="!showParcelsFloatingScrollbar">
                    <div class="sm-floating-hscroll-label" title="Scorrimento orizzontale della tabella">
                        <i class="fas fa-arrows-alt-h"></i>
                        <span>Scorri</span>
                    </div>
                    <div #parcelsHScroll class="sm-floating-hscroll-track"
                         (scroll)="parcelsHScrollCtl.syncFromBar()">
                        <div class="sm-floating-hscroll-inner" [style.width.px]="parcelsHScrollCtl.innerWidth"></div>
                    </div>
                </div>
                -->
                </div>

                <!-- Tabella Instradamenti (Vista Instradamenti) disabilitata temporaneamente
                <div *ngIf="showRoutingView && filteredRoutingSummaries.length > 0" class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead class="table-light">
                        <tr>
                            <th style="width: 60px;">#</th>
                            <th>Nome Instradamento</th>
                            <th>Data</th>
                            <th class="text-center">Bolle</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let routing of filteredRoutingSummaries; let i = index">
                            <td class="text-muted">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
                            <td class="fw-medium">
                                <div class="d-flex align-items-center gap-1">
                                    <span>{{ routing.routingCode }}</span>
                                    <i class="fas fa-copy copy-icon"
                                       (click)="$event.stopPropagation(); copyToClipboard(routing.routingCode || '', 'instradamento')"
                                       [title]="'Copia instradamento: ' + (routing.routingCode || '')"
                                       *ngIf="routing.routingCode"></i>
                                </div>
                            </td>
                            <td>{{ routing.routingDate | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">
                                <span class="badge bg-primary">{{ routing.waybillsCount | number }}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                -->


                <!-- Stato iniziale: nessuna ricerca effettuata -->
                <div class="empty-state text-center" *ngIf="currentPageItemsCount === 0 && !hasSearchBeenPerformed && !isLoading">
                    <div class="empty-state-icon mb-3">
                        <i class="fas fa-search fa-3x text-muted"></i>
                    </div>
                    <h5 class="empty-state-title text-muted mb-2">Effettua una ricerca</h5>
                    <p class="empty-state-subtitle text-muted small mb-0">
                        Utilizza i filtri per cercare i dati da visualizzare.
                    </p>
                </div>

                <!-- Caricamento in corso (nessun dato ancora nella vista corrente) -->
                <div class="empty-state text-center" *ngIf="currentPageItemsCount === 0 && hasSearchBeenPerformed && isLoading">
                    <div class="empty-state-icon mb-3">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
                        </div>
                    </div>
                    <h5 class="empty-state-title text-muted mb-2">Ricerca in corso...</h5>
                </div>

                <!-- Nessun risultato trovato -->
                <div class="empty-state text-center"
                     *ngIf="currentPageItemsCount === 0 && hasSearchBeenPerformed && !isLoading">
                    <div class="empty-state-icon mb-3">
                        <i class="fas fa-3x text-muted"
                           [ngClass]="showRoutingView ? 'fa-route' : (showParcelsView ? 'fa-boxes' : 'fa-inbox')"></i>
                    </div>
                    <h5 class="empty-state-title text-muted mb-2">
                        {{ showRoutingView ? 'Nessun instradamento trovato' :
                        (showParcelsView ? ('SHIPMENT_MANAGEMENT.NO_PARCELS_FOUND' | translate) :
                        ('SHIPMENT_MANAGEMENT.NO_WAYBILLS_FOUND' | translate)) }}
                    </h5>
                    <p class="empty-state-subtitle text-muted small mb-0">
                        {{ 'SHIPMENT_MANAGEMENT.NO_DATA_HINT' | translate }}
                    </p>
                </div>

                <!-- Pagination Controls -->
                <div class="pagination-container"
                     *ngIf="currentResultCount > 0">
                    <div class="pagination-controls">
                        <button class="pagination-btn" (click)="onPageChange(1)" [disabled]="currentPage === 1"
                                aria-label="Prima pagina" title="Prima pagina">
                            <i class="fas fa-angles-left"></i>
                        </button>
                        <button class="pagination-btn" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
                                [attr.aria-label]="'PAGINATION.PREVIOUS' | translate" [title]="'PAGINATION.PREVIOUS' | translate">
                            <i class="fas fa-chevron-left"></i>
                        </button>
                        <div class="page-numbers">
                            <ng-container *ngFor="let page of getPageItems(); trackBy: trackByPageItem">
                              <span class="pagination-ellipsis" *ngIf="page === null">…</span>
                              <button *ngIf="page !== null" class="pagination-number"
                                    [class.active]="page === currentPage" (click)="onPageChange(page)" [attr.aria-label]="'Pagina ' + page"
                                    [title]="'Vai alla pagina ' + page">
                                {{ page }}
                            </button>
                            </ng-container>
                        </div>
                        <!-- Vai a pagina: il pulsante si trasforma in un campo per digitare il numero -->
                        <div class="page-jump">
                          <button class="pagination-btn" *ngIf="!isPageJumpOpen" (click)="openPageJump()"
                                  aria-label="Vai a pagina" title="Vai a pagina...">
                            <i class="fas fa-hashtag"></i>
                          </button>
                          <div class="page-jump-field" *ngIf="isPageJumpOpen">
                            <input #pageJumpInput type="number" class="page-jump-input" min="1"
                                 [max]="getTotalPages()" [value]="pageJumpValue" [placeholder]="' / ' + getTotalPages()"
                                 (input)="pageJumpValue = $any($event.target).value"
                                 (keydown.enter)="applyPageJump()" (keydown.escape)="closePageJump()" (blur)="closePageJump()">
                            <button type="button" class="page-jump-go"
                                  (mousedown)="$event.preventDefault()" (click)="applyPageJump()"
                                  aria-label="Vai" title="Vai alla pagina">
                            <i class="fas fa-level-down-alt fa-rotate-90"></i>
                          </button>
                          </div>
                        </div>
                        <span class="pagination-info">
              {{ ((currentPage - 1) * itemsPerPage) + 1 | number }} - {{ Math.min(currentPage * itemsPerPage, currentResultCount) | number }}
                            {{ 'PAGINATION.OF' | translate }} {{ currentResultCount | number }}
            </span>
                        <!-- Vai all'elemento: porta alla pagina che contiene l'elemento con il numero digitato -->
                        <div class="page-jump">
                          <button class="pagination-btn" *ngIf="!isItemJumpOpen" (click)="openItemJump()"
                                  aria-label="Vai a elemento" title="Vai all'elemento numero...">
                            <i class="fas fa-list-ol"></i>
                          </button>
                          <div class="page-jump-field" *ngIf="isItemJumpOpen">
                            <input #itemJumpInput type="number" class="page-jump-input" min="1"
                                   [max]="currentResultCount" [value]="itemJumpValue" [placeholder]="' / ' + currentResultCount"
                                   (input)="itemJumpValue = $any($event.target).value"
                                   (keydown.enter)="applyItemJump()" (keydown.escape)="closeItemJump()" (blur)="closeItemJump()">
                            <button type="button" class="page-jump-go"
                                    (mousedown)="$event.preventDefault()" (click)="applyItemJump()"
                                    aria-label="Vai" title="Vai all'elemento">
                              <i class="fas fa-level-down-alt fa-rotate-90"></i>
                            </button>
                          </div>
                        </div>
                        <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                                [disabled]="currentPage === getTotalPages()" [attr.aria-label]="'PAGINATION.NEXT' | translate"
                                [title]="'PAGINATION.NEXT' | translate">
                            <i class="fas fa-chevron-right"></i>
                        </button>
                        <button class="pagination-btn" (click)="onPageChange(getTotalPages())"
                                [disabled]="currentPage === getTotalPages()"
                                aria-label="Ultima pagina" title="Ultima pagina">
                            <i class="fas fa-angles-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Access denied message -->
        <div class="text-center py-5" *ngIf="!canRead()">
            <i class="fas fa-lock fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">{{ 'COMMON.ACCESS_DENIED' | translate }}</h5>
            <p class="text-muted">{{ 'COMMON.NO_PERMISSION' | translate }}</p>
        </div>

        <!-- Popup di rinomina di una card salvata (il nome è facoltativo) -->
        <div class="modal fade" [class.show]="isSaveSearchPopupVisible"
             [style.display]="isSaveSearchPopupVisible ? 'block' : 'none'" tabindex="-1"
             *ngIf="isSaveSearchPopupVisible">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content saved-search-modal">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span class="saved-search-modal-icon">
                                <i class="fas fa-pen"></i>
                            </span>
                            Nome dei filtri salvati
                        </h5>
                        <button type="button" class="btn-close" (click)="closeSaveSearchPopup()"></button>
                    </div>
                    <div class="modal-body">
                        <label class="form-label" for="savedSearchNameInput">Nome <span class="text-muted fw-normal">(facoltativo)</span></label>
                        <input #savedSearchNameInput id="savedSearchNameInput" type="text"
                               class="form-control" maxlength="60" autocomplete="off"
                               [(ngModel)]="saveSearchName"
                               (keyup.enter)="confirmRenameSavedSearch()"
                               placeholder="Es. Consegne in ritardo Nord">
                        <p class="saved-search-modal-hint" *ngIf="editingSavedSearch">
                            <i class="fas fa-circle-info"></i>
                            <span>
                                Lascia vuoto per togliere il nome: la card mostrerà la data del salvataggio.
                            </span>
                        </p>
                        <ng-container *ngIf="editingSavedSearch">
                            <div class="saved-search-modal-subtitle">
                                <i class="fas fa-filter"></i>
                                Filtri della card
                                <span class="saved-searches-badge">{{ editingSavedSearch.filters.length }}</span>
                            </div>
                            <div class="saved-search-chips">
                                <span class="saved-search-chip" *ngFor="let f of editingSavedSearch.filters">
                                    <span class="saved-search-chip-label">{{ f.label }}</span>
                                    <span class="saved-search-chip-value">{{ f.value }}</span>
                                </span>
                            </div>
                        </ng-container>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" (click)="closeSaveSearchPopup()">
                            <i class="fas fa-times me-1"></i>
                            Annulla
                        </button>
                        <button type="button" class="btn btn-primary" (click)="confirmRenameSavedSearch()">
                            <i class="fas fa-save me-1"></i>
                            Salva nome
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade" [class.show]="isSaveSearchPopupVisible" *ngIf="isSaveSearchPopupVisible"></div>

        <!-- Popup dettagli di un insieme di filtri salvato -->
        <div class="modal fade" [class.show]="isSavedSearchPopupVisible"
             [style.display]="isSavedSearchPopupVisible ? 'block' : 'none'" tabindex="-1"
             *ngIf="isSavedSearchPopupVisible">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content saved-search-modal">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span class="saved-search-modal-icon">
                                <i class="fas fa-bookmark"></i>
                            </span>
                            {{ selectedSavedSearch ? savedSearchDisplayName(selectedSavedSearch) : 'Filtri salvati' }}
                        </h5>
                        <button type="button" class="btn-close" (click)="closeSavedSearchPopup()"></button>
                    </div>
                    <div class="modal-body" *ngIf="selectedSavedSearch">
                        <div class="saved-search-meta">
                            <span class="saved-search-count">
                                {{ selectedSavedSearch.filters.length }}
                                {{ selectedSavedSearch.filters.length === 1 ? 'filtro' : 'filtri' }}
                            </span>
                            <span class="saved-search-date">
                                <i class="fas fa-clock"></i>
                                Salvati il {{ formatSavedSearchDate(selectedSavedSearch.timestamp) }}
                            </span>
                        </div>
                        <div class="saved-search-modal-subtitle">
                            <i class="fas fa-filter"></i>
                            Filtri della card
                            <span class="saved-searches-badge">{{ selectedSavedSearch.filters.length }}</span>
                        </div>
                        <div class="saved-search-chips">
                            <span class="saved-search-chip" *ngFor="let f of selectedSavedSearch.filters">
                                <span class="saved-search-chip-label">{{ f.label }}</span>
                                <span class="saved-search-chip-value">{{ f.value }}</span>
                            </span>
                        </div>
                        <p class="saved-search-modal-hint">
                            <i class="fas fa-circle-info"></i>
                            <span>
                                "Applica filtri" li riporta nel form di ricerca senza avviarla: premi poi Cerca.
                            </span>
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" (click)="closeSavedSearchPopup()">
                            <i class="fas fa-times me-1"></i>
                            Chiudi
                        </button>
                        <button type="button" class="btn btn-primary"
                                *ngIf="selectedSavedSearch?.state"
                                (click)="applySavedSearch(selectedSavedSearch!); closeSavedSearchPopup()">
                            <i class="fas fa-undo me-1"></i>
                            Applica filtri
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade" [class.show]="isSavedSearchPopupVisible" *ngIf="isSavedSearchPopupVisible"></div>

        <!-- Parcel Edit Popup -->
        <app-parcel-complete-popup
                [visible]="isParcelEditPopupVisible"
                [parcel]="selectedParcel"
                (closed)="closeParcelEditPopup()"
                (completed)="onParcelCompleted($event)">
        </app-parcel-complete-popup>

        <!-- Waybill Completion Popup -->
        <app-waybill-complete-popup
                [visible]="isCarrierPopupVisible"
                [waybill]="selectedWaybill"
                [carriers]="carriers"
                [zones]="zones"
                [routings]="routings"
                [isLoadingZones]="isLoadingZones"
                (closed)="closeCarrierAssignmentPopup()"
                (completed)="onWaybillCompleted($event)">
        </app-waybill-complete-popup>

        <!-- Dealer Detail Popup -->
        <app-dealer-detail-popup
                [visible]="isDealerPopupVisible"
                [dealer]="selectedDealerForDetail"
                [activeTab]="dealerPopupActiveTab"
                (closed)="closeDealerDetailPopup()"
                (tabChanged)="onDealerPopupTabChanged($event)">
        </app-dealer-detail-popup>

        <!-- Client Details Popup -->
        <app-client-details-popup
                [visible]="isClientPopupVisible"
                [clientCode]="selectedClientCodeForDetail"
                (closed)="closeClientDetailPopup()">
        </app-client-details-popup>

        <!-- Carrier Details Popup -->
        <app-carrier-details-popup
                [visible]="isCarrierDetailsPopupVisible"
                [carrierCode]="selectedCarrierCodeForDetail"
                (closed)="closeCarrierDetailPopup()">
        </app-carrier-details-popup>

        <app-waybill-detail-popup
                [visible]="isDetailPopupVisible && (detailPopupData?.type === 'waybill' || detailPopupData?.type === 'ragione-sociale')"
                [code]="detailPopupData?.code ?? ''"
                [type]="detailPopupData?.type ?? 'waybill'"
                [waybill]="selectedWaybillForDetail"
                [dealer]="selectedDealerForDetailPopup"
                [client]="selectedClientForDetailPopup"
                [allParcels]="selectedWaybillParcels"
                [carriers]="carriers"
                [warehouses]="warehouses"
                [brands]="filteredBrands"
                (closed)="closeDetailPopup()"
                (openAxylogPopup)="openAxylogPopupFromDetail($event)"
                (openMailPopup)="openMailPopupFromDetail($event)">
        </app-waybill-detail-popup>

        <app-parcel-detail-popup
                [visible]="isDetailPopupVisible && detailPopupData?.type === 'collo'"
                [code]="detailPopupData?.code ?? ''"
                [parcel]="selectedParcelForDetail"
                [waybill]="selectedWaybillForDetail"
                [dealer]="selectedDealerForDetailPopup"
                [client]="selectedClientForDetailPopup"
                [allParcels]="selectedWaybillParcels"
                [clientsBrands]="clientsBrands"
                [carriers]="carriers"
                (closed)="closeDetailPopup()"
                (openAxylogPopup)="openAxylogPopupFromDetail($event)"
                (openMailPopup)="openMailPopupFromDetail($event)"
                (openInvalidateLoadingListsPopup)="openInvalidateLoadingListsPopupFromDetail($event)">
        </app-parcel-detail-popup>

        <!-- Completion Popup Components -->
        <app-parcel-complete-popup
                [visible]="isParcelCompletePopupVisible"
                [parcel]="selectedParcelForCompletion"
                (closed)="closeParcelCompletePopup()"
                (completed)="onParcelCompleted($event)">
        </app-parcel-complete-popup>

        <!-- ===== DEALER ASSIGNMENT POPUP (popup-overlay style) ===== -->
        <div *ngIf="isDealerAssignmentPopupVisible" class="popup-overlay" (click)="closeDealerAssignmentPopup()">
            <div class="popup-content" style="max-width: 900px;" (click)="$event.stopPropagation()">

                <div class="popup-header">
                    <h3 class="popup-title" style="font-size: 1.25rem;">
                        <i class="fas fa-store me-2 text-warning"></i>
                        {{ 'SHIPMENT_MANAGEMENT.ASSIGN_DEALER' | translate }}
                        <span class="ms-2 text-muted" style="font-size: 1rem; font-weight: 400;" *ngIf="selectedWaybill">
                            − {{ selectedWaybill.waybillCode }}
                        </span>
                    </h3>
                    <button type="button" class="btn-close" (click)="closeDealerAssignmentPopup()">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <div class="popup-body">
                    <div *ngIf="selectedWaybill?.waybillAddressAlias">
                        <div class="mb-1">
                            <small class="text-muted fs-5">
                                <i class="fas fa-tag me-1"></i><b>{{ selectedWaybill?.waybillAddressAlias }}</b>
                            </small>
                        </div>
                        <hr class="my-2">
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bold">
                            <i class="fas fa-search me-2"></i>
                            {{ 'SHIPMENT_MANAGEMENT.DEALER_SEARCH_INSTRUCTION' | translate }}
                        </label>
                        <div class="row g-2">
                            <div class="col-12 col-lg-2">
                                <label class="form-label mb-1">{{ 'SHIPMENT_MANAGEMENT.CODE' | translate }}</label>
                                <input type="text" class="form-control" [value]="dealerSearchCode" (input)="onDealerSearchChange('code', $any($event.target).value)" (keyup.enter)="performDealerSearch()" />
                            </div>
                            <div class="col-12 col-lg-2">
                                <label class="form-label mb-1">{{ 'SHIPMENT_MANAGEMENT.NAME' | translate }}</label>
                                <input type="text" class="form-control" [value]="dealerSearchName" (input)="onDealerSearchChange('name', $any($event.target).value)" (keyup.enter)="performDealerSearch()" />
                            </div>
                            <div class="col-12 col-lg-4">
                                <label class="form-label mb-1">{{ 'SHIPMENT_MANAGEMENT.ADDRESS' | translate }}</label>
                                <input type="text" class="form-control" [value]="dealerSearchAddress" (input)="onDealerSearchChange('address', $any($event.target).value)" (keyup.enter)="performDealerSearch()" />
                            </div>
                            <div class="col-12 col-lg-2">
                                <label class="form-label mb-1">{{ 'SHIPMENT_MANAGEMENT.CITY' | translate }}</label>
                                <input type="text" class="form-control" [value]="dealerSearchCity" (input)="onDealerSearchChange('city', $any($event.target).value)" (keyup.enter)="performDealerSearch()" />
                            </div>
                            <div class="col-12 col-lg-2 d-flex align-items-end">
                                <button type="button" class="btn btn-primary w-100" (click)="performDealerSearch()" [disabled]="isSearchLoading">
                                    <i class="fas" [class.fa-search]="!isSearchLoading" [class.fa-spinner]="isSearchLoading" [class.fa-spin]="isSearchLoading"></i>
                                    <span class="ms-1">{{ 'SHIPMENT_MANAGEMENT.SEARCH' | translate }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive position-relative" style="max-height: 320px; overflow-y: auto;">
                        <table class="table table-hover align-middle mb-0">
                            <thead class="table-light">
                            <tr>
                                <th style="width: 40px"></th>
                                <th>{{ 'SHIPMENT_MANAGEMENT.CODE' | translate }}</th>
                                <th>{{ 'SHIPMENT_MANAGEMENT.NAME' | translate }}</th>
                                <th class="d-none d-lg-table-cell">{{ 'SHIPMENT_MANAGEMENT.ADDRESS' | translate }}</th>
                                <th class="d-none d-md-table-cell">{{ 'SHIPMENT_MANAGEMENT.CITY' | translate }}</th>
                                <th class="d-none d-lg-table-cell">{{ 'SHIPMENT_MANAGEMENT.PROVINCE' | translate }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let d of dealerSearchResults" (click)="selectDealerForAssignment(d)" [class.table-active]="selectedDealerForAssignment?.dealerCode === d.dealerCode" style="cursor: pointer;">
                                <td class="text-center">
                                    <input type="radio" name="dealerSelect" [checked]="selectedDealerForAssignment?.dealerCode === d.dealerCode" />
                                </td>
                                <td class="font-monospace">{{ d.dealerCode }}</td>
                                <td>{{ d.dealerName || '-' }}</td>
                                <td class="d-none d-lg-table-cell">{{ getFullAddress(d) || '-' }}</td>
                                <td class="d-none d-md-table-cell">{{ d.dealerOperatingAddressCity || '-' }}</td>
                                <td class="d-none d-lg-table-cell">{{ d.dealerOperatingAddressProvince || '-' }}</td>
                            </tr>
                            <tr *ngIf="!isSearchLoading && dealerSearchResults.length === 0 && dealerSearchPerformed">                                <td colspan="6" class="text-center text-muted py-3">
                                    <i class="fas fa-info-circle me-1"></i> {{ 'SHIPMENT_MANAGEMENT.NO_RESULTS' | translate }}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div *ngIf="isSearchLoading" style="position:absolute; inset:0; background:rgba(255,255,255,0.6); display:flex; align-items:center; justify-content:center; z-index: 10;">
                            <div class="text-center">
                                <i class="fas fa-spinner fa-spin fa-2x text-secondary"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="popup-footer">
                    <div class="d-flex justify-content-end gap-2">
                        <button type="button" class="btn btn-secondary" (click)="closeDealerAssignmentPopup()">
                            <i class="fas fa-times me-1"></i> {{ 'COMMON.CANCEL' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary" [disabled]="!selectedDealerForAssignment || isSubmitting" (click)="confirmAssignDealer()">
                            <i class="fas" [class.fa-check]="!isSubmitting" [class.fa-spinner]="isSubmitting" [class.fa-spin]="isSubmitting"></i>
                            <span class="ms-2">{{ 'COMMON.CONFIRM' | translate }}</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <!-- ===== END DEALER ASSIGNMENT POPUP ===== -->

        <!-- Status Confirmation Popup -->
        <div class="modal fade status-confirmation-modal" [class.show]="isStatusConfirmationPopupVisible" [style.display]="isStatusConfirmationPopupVisible ? 'block' : 'none'" tabindex="-1" *ngIf="isStatusConfirmationPopupVisible">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-exclamation-triangle text-dark me-2"></i>
                            Conferma Operazione
                        </h5>
                        <button type="button" class="btn-close" (click)="cancelStatusOperation()"></button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-warning">
                            <h6 class="alert-heading">
                                <i class="fas fa-info-circle me-2"></i>
                                Alcune bolle non hanno uno stato ammesso ({{ statusConfirmationEligibleLabel }})
                            </h6>
                            <p class="mb-0">
                                Sono state selezionate bolle con stato diverso da {{ statusConfirmationEligibleLabel }}.
                                Solo le bolle con stato {{ statusConfirmationEligibleLabel }} verranno elaborate per
                                <strong>{{ statusConfirmationData?.operation === 'pdf' ? 'la stampa PDF' : 'l\'invio in Axylog' }}</strong>.
                            </p>
                        </div>

                        <div *ngIf="statusConfirmationData">
                            <h6 class="mb-3">
                                <i class="fas fa-list me-2"></i>
                                Riepilogo bolle selezionate ({{ statusConfirmationData.selectedWaybillCodes.length }})
                            </h6>

                            <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                                <table class="table table-hover mb-0">
                                    <thead class="table-light sticky-top">
                                    <tr>
                                        <th style="width: 50px;" class="text-center">#</th>
                                        <th class="sortable-header">Codice Bolla</th>
                                        <th style="width: 120px;" class="text-center">Stato</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let code of statusConfirmationData.selectedWaybillCodes; let i = index"
                                        [class]="isWaybillEligibleForConfirmation(code) ? 'table-success' : 'table-warning'">
                                        <td class="text-muted text-center">{{ i + 1 }}</td>
                                        <td class="fw-medium">
                                            <span class="font-monospace">{{ code }}</span>
                                        </td>
                                        <td class="text-center">
                        <span class="badge"
                              [class]="isWaybillEligibleForConfirmation(code) ? 'bg-success' : 'bg-warning text-dark'">
                          <i class="fas"
                             [class]="isWaybillEligibleForConfirmation(code) ? 'fa-check-circle' : 'fa-exclamation-triangle'"></i>
                            {{ getWaybillStatus(code) }}
                        </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="d-flex align-items-center">
                                        <span class="badge bg-success me-2">{{ statusConfirmationData.activeWaybillCodes.length }}</span>
                                        <small class="text-success">Bolle {{ statusConfirmationEligibleLabel }} (verranno elaborate)</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex align-items-center">
                                        <span class="badge bg-warning text-dark me-2">{{ statusConfirmationData.nonActiveWaybillCodes.length }}</span>
                                        <small class="text-warning">Bolle con altro stato (verranno saltate)</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="alert alert-info mt-3" *ngIf="statusConfirmationData && statusConfirmationData.activeWaybillCodes.length === 0">
                            <i class="fas fa-info-circle me-2"></i>
                            <strong>Attenzione:</strong> Non ci sono bolle {{ statusConfirmationEligibleLabel }} tra quelle selezionate.
                            L'operazione non può essere completata.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" (click)="cancelStatusOperation()">
                            <i class="fas fa-times me-1"></i>
                            Annulla
                        </button>
                        <button type="button"
                                class="btn btn-primary"
                                (click)="confirmStatusOperation()"
                                [disabled]="!statusConfirmationData || !statusConfirmationData.activeWaybillCodes.length">
                            <i class="fas fa-check me-1"></i>
                            Continua con le bolle {{ statusConfirmationEligibleLabel }}
                            <span class="badge bg-light text-primary ms-2" *ngIf="statusConfirmationData && statusConfirmationData.activeWaybillCodes.length">
                {{ statusConfirmationData.activeWaybillCodes.length }}
              </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade" [class.show]="isStatusConfirmationPopupVisible" *ngIf="isStatusConfirmationPopupVisible"></div>

        <!-- Print Tour Popup -->
        <app-tours-print-popup
                [visible]="isPrintTourPopupVisible"
                [waybills]="filteredWaybills"
                [clientsBrands]="clientsBrands"
                [allTours]="zones"
                (closed)="closePrintTourPopup()"
                (printed)="closePrintTourPopup()">
        </app-tours-print-popup>

    </div>

    <!-- Axylog Detail Popup -->
    <app-axylog-detail-popup
        #axylogDetailPopup
        [visible]="isAxylogDetailPopupVisible"
        [selectedWaybillCodes]="Array.from(selectedWaybillCodes)"
        (confirmed)="onAxylogDetailConfirmed($event)"
        (closed)="onAxylogDetailClosed()">
    </app-axylog-detail-popup>

    <!-- Mail Detail Popup -->
    <app-mail-detail-popup
        #mailDetailPopup
        [visible]="isMailDetailPopupVisible"
        [selectedWaybillCodes]="Array.from(selectedWaybillCodes)"
        [waybills]="waybills"
        (confirmed)="onMailDetailConfirmed($event)"
        (closed)="onMailDetailClosed()">
    </app-mail-detail-popup>

    <app-invalidate-loading-lists-popup
            [visible]="isInvalidateLoadingListsPopupVisible"
            [parcels]="selectedParcelsForInvalidation"
            [isSubmitting]="isInvalidating"
            [initialTab]="loadingListsPopupInitialTab"
            (closed)="onInvalidateLoadingListsPopupClosed()"
            (confirmed)="onInvalidateLoadingListsPopupConfirmed($event)">
    </app-invalidate-loading-lists-popup>

    <!-- Puntualità della consegna, in fondo alla Data Consegna (bolle e colli): indica se la consegna
         è avvenuta entro oppure oltre la Stima Consegna, che è la data massima di consegna.
         Nessun indicatore se manca una delle due date. -->
    <ng-template #deliveryPunctuality let-actual="actual" let-estimated="estimated">
        <ng-container [ngSwitch]="getDeliveryPunctuality(actual, estimated)">
            <span *ngSwitchCase="'on-time'" class="pt-punctuality pt-punctuality--on-time"
                  [attr.data-tooltip]="'Consegnato entro la stima (' + (estimated | date:'dd/MM/yy HH:mm') + ')'">
                <i class="fas fa-circle-check"></i>
            </span>
            <span *ngSwitchCase="'late'" class="pt-punctuality pt-punctuality--late"
                  [attr.data-tooltip]="'Consegnato oltre la stima (' + (estimated | date:'dd/MM/yy HH:mm') + ')'">
                <i class="fas fa-circle-exclamation"></i>
            </span>
        </ng-container>
    </ng-template>

    <!-- Tour Guide Component -->
    <app-tour-guide></app-tour-guide>

    <!-- Torna in alto: pulsante fisso in basso a destra, visibile solo dopo aver scrollato la pagina -->
    <app-scroll-top-button></app-scroll-top-button>
</div>